module.exports = {
	"amp": "&",
	"apos": "'",
	"gt": ">",
	"lt": "<",
	"quot": "\""
};


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/entities/maps/xml.json
// module id = iXwP
// module chunks = 0